import React, { useState } from "react";
import { Editor } from "@tldraw/tldraw";
import SideBarSlider from "./SidebarSlider";
import {
  EyeOpenIcon16,
  EyeClosedIcon16,
} from "pages/flyer/builder/components/SideBar/Aside/NodesList/components/LayersPanel/icons";
import NewEffectSidebar from "./NewEffectSidebar";

interface SidebarBottomToolProps {
  editor: Editor;
  selectedShape: any;
  max: number;
  min: number;
  step: number;
  title: string;
  sliderValue: number;
  setSliderValue: (value: number) => void;
  handleSliderChange: (key: string, value: number) => void;
  prop: string;
  setSelectedShape: (shape: any) => void;
  selectedShapes: any[];
}

const SidebarBottomTool = ({
  editor,
  selectedShape,
  max,
  min,
  step,
  title,
  sliderValue,
  setSliderValue,
  handleSliderChange,
  setSelectedShape,
  prop,
  selectedShapes,
}: SidebarBottomToolProps) => {
  const [isOpenMainBlock, setIsOpenMainBlock] = useState(true);

  // Check if any selected shape has the rounded property and is not of type customText
  const hasRoundedProperty = selectedShapes.some(
    (shape) => shape && shape.props && shape.props.rounded !== undefined && shape.type !== "customText"
  );

  const handleSliderChangeForShapes = (key: string, value: number) => {
    selectedShapes.forEach((shape) => {
      handleSliderChange(key, value);
    });
  };

  return (
    <>
      <div
        style={{
          paddingLeft: "8px",
          paddingRight: "8px",
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "1px",
            backgroundColor: "#E2E2FC",
            marginTop: "8px",
            marginBottom: "8px",
          }}
        />
      </div>
      {isOpenMainBlock && (
        <div className="flex flex-col gap-4">
          {/* <SideBarSlider
              editor={editor}
              max={max}
              min={min}
              step={step}
              title={title}
              sliderValue={sliderValue}
              setSliderValue={(value) => handleSliderChangeForShapes(prop, value)}
              selectedShape={selectedShape}
              prop={prop}
              setSelectedShape={setSelectedShape}
              tooltip="Change the opacity of the shape"
              placement={"bottom"}
              selectedShapes={selectedShapes}
            />
            {selectedShape?.type !== "customDraw" &&
              selectedShape?.type !== "customHighlight" &&
              selectedShapes.some(
                (shape) => shape && shape.type !== "customDraw" && shape.type !== "customHighlight"
              ) &&
              hasRoundedProperty && (
                <>
                  <SideBarSlider
                    editor={editor}
                    max={100}
                    min={0}
                    step={1}
                    title={"Corner radius"}
                    sliderValue={selectedShape?.props?.rounded || 0}
                    setSliderValue={(value) => handleSliderChangeForShapes("rounded", value)}
                    prop="rounded"
                    selectedShape={selectedShape}
                    setSelectedShape={setSelectedShape}
                    tooltip="Change the radius of the corners"
                    placement={"bottom"}
                    selectedShapes={selectedShapes}
                  />
                </>
              )} */}

          <NewEffectSidebar
            editor={editor}
            selectedShape={selectedShape}
            setSelectedShape={setSelectedShape}
            selectedShapes={selectedShapes}
            prop={prop}
            handleSliderChange={handleSliderChangeForShapes}
          />
        </div>
      )}
    </>
  );
};

export default SidebarBottomTool;

interface ToggleEyesIconIconProps {
  isOpen: boolean;
  onClick: any;
}

export const ToggleEyesIcon: React.FC<ToggleEyesIconIconProps> = ({ isOpen, onClick }) => {
  return (
    <span onClick={onClick} className="cursor-pointer">
      {isOpen ? <EyeOpenIcon16 /> : <EyeClosedIcon16 />}
    </span>
  );
};
